import { Program, ProgramPayload } from "@/domain/programs.interface";
import { GetIncludes, ProgramService } from "../../services/program.service";
import { useMutation, useQuery } from "@tanstack/react-query";
import { SearchPayload } from "@/domain/common.interface";

export const useGetPrograms = ({
  search,
  sortField,
  sortOrder,
  pageNumber,
  pageSize,
}: SearchPayload) => {
  const {
    data,
    isLoading: isLoadingPrograms,
    refetch: refetchPrograms,
    isFetching: isFetchingPrograms,
  } = useQuery({
    queryKey: [
      "coyn-programs-manage-list",
      sortField,
      sortOrder,
      pageNumber,
      pageSize,
      search,
    ],
    queryFn: () =>
      ProgramService.search({
        search,
        sortField,
        sortOrder,
        pageNumber,
        pageSize,
      }),
  });

  return {
    data,
    isLoadingPrograms,
    refetchPrograms,
    isFetchingPrograms,
  };
};

export const useCreateProgram = () => {
  return useMutation({
    mutationFn: (data: ProgramPayload) => ProgramService.create(data),
  });
};

export const useGetProgram = (
  programId: string,
  includes: GetIncludes[] = [],
) => {
  const {
    data,
    isLoading: isLoadingProgram,
    refetch: refetchProgram,
    isFetching: isFetchingProgram,
  } = useQuery({
    queryKey: ["coyn-program-get", programId],
    queryFn: () => ProgramService.findById(programId, includes),
  });
  return {
    data,
    isLoadingProgram,
    refetchProgram,
    isFetchingProgram,
  };
};

export const useUpdateProgram = () => {
  return useMutation({
    mutationFn: (payload: { id: string; data: ProgramPayload }) =>
      ProgramService.update({
        id: payload.id,
        data: payload.data,
      }),
  });
};

export const useDeleteProgram = () => {
  return useMutation({
    mutationFn: (id: string) => ProgramService.softDelete(id),
  });
};
